import {
  Cohort,
  COHORTS_WITH_NEW_APPLOVIN_EVENTS,
} from 'nove8/constants/root-constants'
import { getAxonUserData } from 'nove8/helpers/getAxonUserData'
import { useEffect, useRef } from 'react'
import { WOOFZ_REVIEW } from 'root-constants'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useAxonPixelEvent = (): void => {
  const { leadId, leadEmail, cohort, currentPageId } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id,
      leadEmail: state.lead?.email,
      cohort: state.lead?.cohort,
      currentPageId: state.currentPageId,
    })),
  )

  const sentPageIdRef = useRef<string | null>(null)
  const wasSentRef = useRef(false)

  useEffect(() => {
    if (!leadId || !currentPageId) {
      return
    }

    if (COHORTS_WITH_NEW_APPLOVIN_EVENTS.includes(cohort as Cohort)) {
      if (sentPageIdRef.current === currentPageId) {
        return
      }
      sentPageIdRef.current = currentPageId

      window.axon?.('track', 'page_view', {
        user_data: getAxonUserData(leadId, leadEmail),
      })

      return
    }

    if (wasSentRef.current || window.location.href.includes(WOOFZ_REVIEW)) {
      return
    }

    wasSentRef.current = true

    window.axon?.('track', 'page_view', {
      user_data: getAxonUserData(leadId, leadEmail),
    })
  }, [leadId, leadEmail, currentPageId, cohort])
}
